import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import UserApi from "src/store/slices/authentication/Token.api";
import authSlice from "src/store/slices/authentication/auth.slice";
import BaseApi from "src/store/BaseApi";
import timerReducer from "./slices/timer/timer.slice";
import clientSlice from "./slices/client/client.slice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    timer: timerReducer,
    client: clientSlice,
    [UserApi.reducerPath]: UserApi.reducer,
    [BaseApi.reducerPath]: BaseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(UserApi.middleware, BaseApi.middleware);
  },
});

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
